module.exports = __webpack_public_path__ + "static/img/bus-tyre.e8e2b311.png";